import styled, { css } from "styled-components";

export const UnreadCount = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  background: red;
  color: white;
  border-radius: 50%;

  text-align: center;
  line-height: 18px;
  font-size: 10px;
  width: 17px;
  height: 18px;
  user-select: none;
`;

export const NotificationList = styled.ul`
  display: ${(props) => (props.open ? "block" : "none")};
  position: absolute;
  width: 25rem;
  left: -25rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #ddd;
  padding: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  list-style: none;
  user-select: none;
  h3 {
    margin-top: 0;
  }
  .mention {
    text-decoration: underline;
  }
`;

export const HeaderContent = styled.div`
  display: flex;

  justify-content: space-between;

  .new-notification {
    height: 0.8rem;
    width: 0.8rem;
    background: linear-gradient(to right, #118052, #40e5a0);
    border-radius: 50%;
    flex-shrink: 0;
  }
`;

export const ScrollableContainer = styled.div`
  max-height: 28rem;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background: #118052;
    width: 10px;
    border-radius: 6px;
  }
`;

export const NotificationItem = styled.li`
  min-height: 6rem;
  align-items: flex-start;

  font-size: 0.8rem;
  cursor: pointer;
  display: flex;

  margin-bottom: 0.8rem;

  &:hover {
    background: #cff8e7;
    border-radius: 8px;
  }

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`;

export const Options = styled.div`
  font-size: 0.8rem;
  display: flex;
  cursor: pointer;

  span:first-child {
    margin-right: 1rem;
  }
`;

export const OptionItem = styled.span`
  font-weight: 600;

  ${({ viewAll }) =>
    viewAll
      ? css`
          border-bottom: 2px solid #118052;
          padding-bottom: 5px;
          transition: border-color 0.5s ease, opacity 0.5s ease;
        `
      : css`
          opacity: 0.5;
        `}
`;

export const Avatar = styled.img`
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
`;

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  margin-right: 1rem;
  line-height: 1rem;
  width: 100%;

  .header-notification {
    color: #118052;
    font-weight: bold;
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }

  p {
    display: block;
    border: 1px solid lightgray;
    border-radius: 4px;
    padding: 0.5rem 0 0.25rem 0.5rem;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.6rem;
  justify-content: space-between;
  color: #a9aeb4;
  font-weight: 600;
`;

export const Footer = styled.footer`
  height: 2rem;
  margin-top: 1rem;
  border-top: 1px solid lightgray;
  display: flex;
  align-items: center;

  span {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #118052;
    font-size: 0.8rem;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const LabelStatus = styled.span`
  padding: 0.1rem 0.2rem;
  border-radius: 0.2rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#F8E47C"
      : status === "done"
      ? "#118052"
      : status === "doneLate"
      ? "#9F2D1D"
      : status === "pending"
      ? "#EFF1F5"
      : "#FFBAAB"};

  color: ${({ status }) =>
    status === "doing"
      ? "#786A23"
      : status === "done" || status === "doneLate"
      ? "#EFF1F5"
      : status === "pending"
      ? "#7E858F"
      : "#D93333"};
`;
export const LabelSpan = styled.span`
  color: ${({ status }) =>
    status === "done"
      ? "#118052"
      : status === "doing"
      ? "#807228"
      : status === "late"
      ? "#d93333"
      : status === "doneLate"
      ? "#9F2D1D"
      : "#7e858f"};
`;
